import React, { Component } from 'react'
import * as d3 from "d3";
import elementResizeEvent from 'element-resize-event'

class BarChart extends Component {
  constructor(props){
    super(props);

    this.state = {
      width: this.props.width,
      margin: {top: 10, right: 10, bottom: 20, left: 200},
      ypadding: 0.1,
      yspacing: 20
    }
  }

  componentDidMount() {
    var charName = this.props.name
    var chart = document.getElementById(charName)
    elementResizeEvent(chart, () =>
      this.setState({
        width: chart.offsetWidth,
      })
    )
    this.setState({
      width: chart.offsetWidth
    })
  }

  createBarChart() {
    var charName = this.props.name
    var data = this.props.data;
    var width = this.state.width
    var height = data.length * this.state.yspacing //this.props.height

    var chart = d3.select("#" + charName)
    chart.selectAll("svg").remove() //remove previously created chart

    // set the dimensions and margins of the graph
    var margin = this.state.margin
    width = width - margin.left - margin.right

    // set the ranges
    var y = d3.scaleBand()
              .range([0, height])
              .padding(this.state.ypadding)

    var x = d3.scaleLinear()
              .range([0, width])

    // append the svg object to the body of the page
    // append a 'group' element to 'svg'
    // moves the 'group' element to the top left margin
    var svg = chart.append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

    // Scale the range of the data in the domains
    x.domain([0, 100]) //0%-100%
    y.domain(data.map(function(d) { return d.label; }))

    // append the rectangles for the bar chart
    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("fill", function(d) {
        if(d.value === 100) {
          return "rgb(113,179,124)"
        }
        else {
          return "rgb(250,191,64)"
        }
      })
      .attr("width", function(d) {return x(d.value); } )
      .attr("y", function(d) { return y(d.label); })
      .attr("height", y.bandwidth())
      .attr("id", function(d, index) { return "bar" + index; })
      .on("mouseover", function(d) {
        var bar = d3.select(this)
        var tooltip = d3.select("#" + charName).append("div")
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        var xPosition = x(d.value) + margin.left
        var tooltipWidth = context.measureText(d.label + ": " + d.value + "%").width

        if(xPosition + tooltipWidth > width) {
          xPosition =  xPosition + (width - (xPosition + tooltipWidth))
        }
        var yPosition = d3.mouse(this)[1]

        bar.style("opacity", 0.8)
        tooltip.attr("id", "bar-tooltip")
        tooltip.style("left", xPosition + "px")
        tooltip.style("top", yPosition + "px")

        if(d.value === 100) {
          tooltip.style("border", "2px solid rgb(113,179,124)")
        }
        else {
          tooltip.style("border", "2px solid rgb(250,191,64)")
        }

        tooltip.append("p").text("Compliance Rating")
        tooltip.append("p").text(d.label + ": " + d.value + "%")
      })
      .on("mouseout", function(d) {
          d3.select(this).style("opacity", 1.0)
          d3.select("#" + charName).select("div").remove()
      });

    // add chart's label
    svg.append("g")
      .call(d3.axisLeft(y))
      .selectAll(".tick text")
      .call((data) => this.formatLabel(data, this))

    // add chart's label
    svg.append("g")
    .attr("transform", "translate(" + 0+ "," + height + ")")
    .call(d3.axisBottom(x))

    //add percentage text
    svg.selectAll(".text")
      .data(data)
      .enter()
      .append("text")
      .attr("x", function(d) {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')

        if(d.value >= 90) {
          return x(d.value) - context.measureText("" + d.value + "%").width - 10
        }
        return x(d.value) + 5;
      })
      .attr("y", function(d) { return y(d.label); })
      .attr("dy", "12px")
      .attr("font-size", "12px")
      .attr("fill", function(d) {
        if(d.value >= 90) {
          return "white"
        }
        return "black"
      })
      .style("font-weight", "bold")
      .text(function(d) { return d.value + "%"; })
      .on("mouseover", function(d, index) {
        var tooltip = d3.select("#" + charName).append("div")
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        var xPosition = x(d.value) + margin.left + 10
        var tooltipWidth = context.measureText(d.label + ": " + d.value + "%").width

        if(xPosition + tooltipWidth > width) {
          xPosition =  xPosition + (width - (xPosition + tooltipWidth))
        }

        var yPosition = d3.mouse(this)[1]

        d3.select("#" + charName).select("#bar" + index).style("opacity", 0.8)
        tooltip.attr("id", "bar-tooltip")
        tooltip.style("left", xPosition + "px")
        tooltip.style("top", yPosition + "px")

        if(d.value === 100) {
          tooltip.style("border", "2px solid rgb(113,179,124)")
        }
        else {
          tooltip.style("border", "2px solid rgb(250,191,64)")
        }

        tooltip.append("p").text("Compliance Rating")
        tooltip.append("p").text(d.label + ": " + d.value + "%")
      })
      .on("mouseout", function(d, index) {
          d3.select("#" + charName).select("#bar" + index).style("opacity", 1)
          d3.select("#" + charName).select("div").remove()
      });
  }


  formatLabel(text, parent) {
    text.each(function(d, index) {
      var charName =  parent.props.name
      var text = d3.select(this)
      var label = text.text()
      var y = text.attr("y")
      var dy = parseFloat(text.attr("dy"))
      var tspan = text.text(null).append("tspan")
      .attr("font-size", "12px")
      .attr("x", -10).attr("y", y)
      .attr("dy", dy + "em")
      .on("mouseover", function(d) {
        var margin =  parent.state.margin
        var label = d3.select(this)
        var tooltip = d3.select("#"+charName).append("div")
        var coordinates = d3.mouse(this);
        var offset = 2;
        var xPosition = coordinates[0] + margin.left + offset;
        var yPosition = coordinates[1] + margin.top + (index * parent.state.yspacing) + (index * parent.state.ypadding);

        label.style("opacity", 0.8)
        tooltip.attr("id", "label-tooltip")
        tooltip.style("left", xPosition + "px")
        tooltip.style("top", yPosition + "px")
        tooltip.style("display", "block")
        tooltip.style("border", "2px solid rgb(250,191,64)")
        tooltip.style("font-size", "14px")

        tooltip.append("p").text(d)
      })
      .on("mouseout", function(d, index) {
          d3.select("#" + charName).select("#label" + index).style("opacity", 1)
          d3.select("#" + charName).select("div").remove()
      });


      if(label.length > 30) {
        tspan.text(label.slice(0, 26) + "...")
      }
      else {
        tspan.text(label)
      }

    })
  }

  render() {
    return (
      <div className="bar-chart">
        <div className='chart-title'>
          { this.props.label }
        </div>
        <div className="chart-area" id={ this.props.name }>
          { this.createBarChart() }
        </div>
      </div>
    )
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/views/components/charts/bar_chart.js